import React from 'react'
// import { cloneDeep } from 'lodash'
import Pagination from "./paginationView"
export default class pagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allRecords: [],
            selectedRecords: [],
            currentPage: null,
            totalPages: null,
            pageLimit: null
        }
    }
    componentWillMount() {
        this.setState({
            allRecords: this.props.data
        })
    }

    onPageChanged = (data) => {
        let { allRecords } = this.state;
        if(!allRecords){
            allRecords=this.props.data;
        }
        const { currentPage, totalPages, pageLimit } = data;
        const offset = (currentPage - 1) * pageLimit;
        const selectedRecords = allRecords.slice(offset, offset + pageLimit);
        this.setState({ currentPage, selectedRecords, totalPages });
        this.props.changeData(selectedRecords, currentPage, pageLimit)
    };

    render() {
      
        const { totalRecords, pageLimit, currentPage } = this.props;
        if (totalRecords === 0) return null;
        return (
            <Pagination
                totalRecords={totalRecords && totalRecords}
                pageLimit={pageLimit}
                pageNeighbours={1}
                onPageChanged={this.onPageChanged}
                currentPage={currentPage}
            />
        )
    }
}